import React from 'react'

import './Common_Back_Header.css'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { postReorder } from '../../../features/order/orderSlice'
import { getAllCart } from '../../../features/cart/cartSlice'

const Common_Back_Header = ({ delivered, backNavigation, showReOrder }) => {

  const navigate = useNavigate()

  const dispatch = useDispatch();
const reOrder = async (id) => {
    try {
      // Use unwrap() to get the result of the action directly
      const res = await dispatch(postReorder(id)).unwrap();
      if (res?.success) {
        await dispatch(getAllCart(true)).unwrap();
      } else {
        // await setAleart({ show: true, text: res?.errors, sub_text: "" });
      }
    } catch (error) {
      console.error("Error during reorder:", error);
    }
  };
  return (
    <section className='Common_Back_Header'>
      <p className='back_text' onClick={() => {
        if (typeof backNavigation === "number") {
          navigate(backNavigation);
        } else {
          navigate(backNavigation || "/");
        }
      }}>Back</p>

      {/* {showReOrder && (
        <div className='btn_holder' onClick={() => { navigate("/cart") }}>
          <Green_Btn btn_name="Reorder"  onClick={reOrder}/>
        </div>
      )} */}


    </section>
  )
}

export default Common_Back_Header
